<!-- menú para computadores -->
<ng-template #desktopMenu let-idx="idx" let-menu="menu" let-title="title">
	<ul [id]="'dropdown-'+title" class="dropdown-content" apply="theme" color="background">
		<ng-container *ngFor="let item of menu | keys;let i = index;">
			<ng-container
				*ngIf='(((menu[item] || []) | keys) | json) === (({id: "0", link: "n"} | keys) | json); else nextMenu'>
				<li>
					<ng-container *ngIf="user?.userPermits?.indexOf(menu[item].id) !== -1; else locked">
						<a apply="theme" background="section" class="link-page" [routerLink]="[menu[item].link]"
							routerLinkActive="router-link-active" mouse-action="background-section-hover">
							{{item | name}}
						</a>
					</ng-container>
					<ng-template #locked>
						<a apply="theme" background="section" mouse-action="background-section-hover"
							class="disabled">{{item | name}}</a>
					</ng-template>
				</li>
			</ng-container>
			<ng-template #nextMenu>
				<li>
					<a apply="theme" background="section" [class]="'dropdown-nav'+(idx + 1)"
						[attr.data-target]="'dropdown-'+title+'-child'+i" mouse-action="background-section-hover">
						{{item | name}}
						<i class="material-icons right margin-all-0">arrow_right</i>
					</a>
				</li>
				<ng-container *ngIf="(((menu[item] || []) | keys).length > 0)">
					<ng-container
						*ngTemplateOutlet="desktopMenu;context:{'idx':(idx + 1), 'menu':menu[item], 'title':title+'-child'+i, 'lastName':item}">
					</ng-container>
				</ng-container>
			</ng-template>
		</ng-container>
	</ul>
</ng-template>

<div class="navbar-fixed">
	<nav apply="theme" background="theme">
		<div class="nav-wrapper">
			<!-- Sección para el Incono -->
			<a tabindex="-1" [routerLink]="[user?.userHome || '/Home']" class="brand-logo center-all" style="height: 100%;">
				<img src="assets/img/gc_balanced1.png" alt="logo">
			</a>
			<!-- Sección para el menú desplegable -->
			<a data-target="mobileNav" class="sidenav-trigger"><i class="material-icons">menu</i></a>
			<ul id="principalMenu" apply="theme" color="theme" class="left hide-on-med-and-down" style="margin-left: 174px;">
				<ng-container *ngFor="let item of (user?.userMenu || []) | keys;let i = index;">
					<li>
						<a class="dropdown-nav1" [attr.data-target]="'dropdown-node'+i">
							<p class="margin-all-0">
								{{item | name}}<i class="material-icons right">arrow_drop_down</i>
							</p>
						</a>
					</li>
					<ng-container *ngIf="((user?.userMenu[item] || []) | keys).length > 0">
						<ng-container
							*ngTemplateOutlet="desktopMenu;context:{'idx':1, 'menu':user?.userMenu[item], 'title':'node'+i}">
						</ng-container>
					</ng-container>
				</ng-container>
			</ul>
			<!-- Sección para el nombre -->
			<ul class="right hide-on-med-and-down" apply="theme" color="theme">
				<li>
					<a class="dropdown-nav" data-target="downLogout">
						<p *ngIf="!user" class="margin-all-0">Bienvenido&nbsp;</p>
						<p *ngIf="user" class="margin-all-0">
							{{user.userType == '4' ? user.userName : user.userId}}
							<i class="material-icons right">arrow_drop_down</i>
						</p>
					</a>
				</li>
			</ul>
		</div>
	</nav>
</div>
<!-- Menú de descoenxión para computadores -->
<ul id='downLogout' class='dropdown-content' apply="theme" color="background">
	<app-dropdown-logout></app-dropdown-logout>
</ul>
<!-- Menú para moviles y tablets -->
<ul class="sidenav sidenav-nav" id="mobileNav" apply="theme" color="background">
	<!-- Sección para el icono -->
	<li>
		<div class="user-view border-bottom" apply="theme" border="theme">
			<div class="background">
				<img class="adaptable" src="assets/img/landing.png">
			</div>
			<a class="center-all"><img filter="theme" apply="theme" src="assets/img/gc_balanced1.png"></a>
			<a *ngIf="user" style="margin-top:15px;"
				class="center-all"><span>{{user.userType == '4' ? user.userName : user.userId}}</span></a>
		</div>
	</li>
	<!-- Sección para el menú desplegable -->
	<li>
		<ul class="collapsible" data-collapsible="expandable">
			<ng-container *ngFor="let item of (user?.userMenu || []) | keys;let i = index;">
				<li>
					<div tabindex="-1" class="collapsible-header change-icon">
						<i class="material-icons auto-height left">expand_more</i>
						<p class="margin-all-0">{{item | name}}</p>
					</div>
					<div class="collapsible-body" tabindex="-1">
						<ng-container *ngIf="((user?.userMenu[item] || []) | keys).length > 0">
							<ng-container
								*ngTemplateOutlet="mobileMenu;context:{'idx':1, 'menu':user?.userMenu[item], 'title':'node'+i}">
							</ng-container>
						</ng-container>
					</div>
				</li>
			</ng-container>
		</ul>
	</li>
	<li>
		<div class="divider" apply="theme" background="theme"></div>
	</li>
	<!-- Sección para desconexión -->
	<app-dropdown-logout></app-dropdown-logout>
</ul>
<!-- menú para tablets y celulares -->
<ng-template #mobileMenu let-idx="idx" let-menu="menu" let-title="title">
	<ul class="collapsible" apply="theme" color="background">
		<ng-container *ngFor="let item of menu | keys;let i = index;">
			<ng-container
				*ngIf='(((menu[item] || []) | keys) | json) === (({id: "0", link: "n"} | keys) | json); else nextMenu'>
				<ng-container *ngIf="user?.userPermits?.indexOf(menu[item].id) !== -1; else locked">
					<div tabindex="-1" class="collapsible-header" [style.paddingLeft.px]="(idx * 8) + 16" apply="theme"
						[routerLink]="[menu[item].link]" routerLinkActive="router-link-active">
						<i class="material-icons auto-height left" style="color:inherit;">link</i>
						<a style="color:inherit; padding: 0;">{{item | name}}</a>
					</div>
				</ng-container>
				<ng-template #locked>
					<div tabindex="-1" class="collapsible-header" [style.paddingLeft.px]="(idx * 8) + 16">
						<i class="material-icons auto-height left disabled">link_off</i>
						<a class="disabled" style="padding: 0;">{{item | name}}</a>
					</div>
				</ng-template>
			</ng-container>
			<ng-template #nextMenu>
				<li>
					<div tabindex="-1" class="collapsible-header change-icon" [style.paddingLeft.px]="(idx * 8) + 16"><i
							class="material-icons auto-height left">expand_more</i>
						<p class="margin-all-0">{{item | name}}</p>
					</div>
					<div class="collapsible-body" tabindex="-1">
						<ng-container *ngIf="(((menu[item] || []) | keys).length > 0)">
							<ng-container
								*ngTemplateOutlet="mobileMenu;context:{'idx':(idx + 1), 'menu':menu[item], 'title':title+'-child'+i, 'lastName':item}">
							</ng-container>
						</ng-container>
					</div>
				</li>
			</ng-template>
		</ng-container>
	</ul>
</ng-template>